import { render, staticRenderFns } from "./fixedBottom.vue?vue&type=template&id=6be2a0bb&scoped=true"
import script from "./fixedBottom.vue?vue&type=script&lang=js"
export * from "./fixedBottom.vue?vue&type=script&lang=js"
import style0 from "./fixedBottom.vue?vue&type=style&index=0&id=6be2a0bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be2a0bb",
  null
  
)

export default component.exports